module.exports = __webpack_public_path__ + "media/components/Application/Sponsors/Index/howto2-21b36e31a7da18e44fa231c0f8afe6be.png";